/** 棕色尘埃两周年抽奖活动 */

import service from "@/plugins/request";

export function apiDrawActivity() {
  return service({
    url: "/v1/draw/getActivity",
    method: "GET"
  });
}

export function apiDrawAddGift(data) {
  return service({
    url: "/v1/protected/draw/addGiftLog",
    method: "POST",
    data
  });
}

export function apiDrawGetCookie(data) {
  return service({
    url: "/v1/protected/draw/getCookie",
    method: "POST",
    data
  });
}

export function apiDrawSetCookie(data) {
  return service({
    url: "/v1/protected/draw/setCookie",
    method: "POST",
    data
  });
}

export function apiDrawList(params) {
  return service({
    url: "/v1/draw/list",
    method: "GET",
    params
  });
}
